import {
  Box,
  VStack,
  HStack,
  Button,
  useColorModeValue,
  StackProps,
} from "@chakra-ui/react";
import { useState, ReactNode, ReactElement, useEffect } from "react";

export interface TabOption {
  id: string;
  label: string;
  icon?: ReactElement;
  content: ReactNode;
}

interface TabSelectorProps extends StackProps {
  options: TabOption[];
  onOptionChange?: (optionId: string) => boolean | void;
  optionId?: string;
  variant?: "pills" | "tabs";
  size?: "sm" | "md" | "lg";
}

const TabSelector = ({
  options,
  onOptionChange,
  optionId,
  variant = "pills",
  size = "md",
  ...props
}: TabSelectorProps) => {
  const [selectedOptionId, setSelectedOptionId] = useState<string>(
    optionId || options[0]?.id || ""
  );

  const handleOptionChange = (optionId: string) => {
    const canChange = onOptionChange?.(optionId);

    if (canChange || canChange === undefined) {
      setSelectedOptionId(optionId);
    }
  };

  useEffect(() => {
    setSelectedOptionId(optionId || options[0]?.id || "");
  }, [optionId]);

  const bgColor = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  const selectedOption = options.find(
    (option) => option.id === selectedOptionId
  );

  const buttonSizes = {
    sm: { py: 2, fontSize: "xs", borderRadius: "md" },
    md: { py: 8, fontSize: "md", borderRadius: "lg" },
    // lg: { py: 4, fontSize: "lg", borderRadius: "xl" },
  };

  const buttonSize = buttonSizes[size];

  return (
    <VStack w="full" spacing={4} align="stretch" {...props}>
      {/* Options Selector */}
      <HStack w="full" spacing={2} justifyContent={"center"}>
        {options.map((option) => (
          <Button
            key={option.id}
            minW="30%"
            maxW="50%"
            flex={1}
            variant={selectedOptionId === option.id ? "outline" : "ghost"}
            colorScheme={selectedOptionId === option.id ? "blue" : "gray"}
            leftIcon={option.icon}
            onClick={() => handleOptionChange(option.id)}
            {...buttonSize}
            border="2px solid"
            borderColor={`${
              selectedOptionId === option.id ? "blue.500" : "gray.200"
            }`}
            py={6}
            whiteSpace="wrap"
            // py={8}
            bg="white"
            fontWeight="medium"
            color="gray.800"
          >
            {option.label}
          </Button>
        ))}
      </HStack>

      {/* Content Card */}
      <Box w="full" position="relative">
        {selectedOption?.content}
      </Box>
    </VStack>
  );
};

export default TabSelector;
